import React, { Fragment } from "react";

import R from "ramda";

import { Divider, sideForIndex } from "src/components";
import Embed, { isActiveArticle } from "src/components/Embed";

const getArticles = ({ contentfulPage: { id, articles } }) =>
  R.pipe(
    R.filter(
      article =>
        article.archivePages &&
        R.find(R.propEq("id", id), article.archivePages) &&
        isActiveArticle(article, true)
    ),
    R.sortBy(article => article.publicationDate),
    R.reverse
  )(articles);

const ArticleArchive = props => {
  const articles = getArticles(props.pageData);

  if (articles && !R.isEmpty(articles)) {
    return articles.map((article, index) => (
      <Fragment key={articles.id}>
        <Embed
          {...article}
          embedStyle="archive"
          theme={props.pageData.contentfulPage.theme}
        />
        {index !== articles.length - 1 && (
          <Divider key="divider" side={sideForIndex(index)} mb={3} />
        )}
      </Fragment>
    ));
  }
  return <div>[article archive]</div>;
};

export default ArticleArchive;



// WEBPACK FOOTER //
// ./src/components/Content/Module/ArticleArchive.js